const theme = {
  body_background_color: '#035271',

  logo_image_url: 'museepulperie.png',
  header_full_height: true,
  number_font: `'Montserrat', sans-serif`,

  button_color: '#76c056',
  button_text_weight: 700,
  button_radius: 15,

  button_half_border_color: '#76c056',
  button_half_resize_label: true,

  footer_border_color: '#eee',

  text_font: `'Montserrat', sans-serif`,

  title_font: `'Montserrat', sans-serif`,
}
export const museepulperie = {
  ...theme,
}

export const musee_pulperie_avec_logo = {
  ...theme,
  token_url: 'museepulperie.png',
  token_width: '70',
  number_hidden: true,
  title_margin: '10px',
}
